<template>
  <div>
    <v-dialog v-model="dialog" scrollable width="500" persistent>
      <v-card style="border-radius:8px">
        <v-card-title class="pa-0 ma-0">
          <v-toolbar
            color="primary"
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left :color="'yellow'">mdi-cards</v-icon>
              <v-icon left :color="'red'">mdi-cards</v-icon>Cartões
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="dialog=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="teamsTabs" grow>
            <v-tab v-for="(title, index) in [homeTeam, awayTeam]" :key="index">{{title.team_name}}</v-tab>
            <v-tabs-items v-model="teamsTabs">
              <v-tab-item v-for="(team, index) in [homeTeam, awayTeam]" :key="index">
                <v-card>
                  <v-data-table
                    :headers="headers"
                    :items="available_squad_numbers(team.squads)"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center">
                        <div class="icon-stack">
                          <v-icon
                            large
                            :color="index<1? 'primary': 'blue-grey darken-1'"
                            class="icon-stack-1x"
                          >fa-tshirt</v-icon>
                          <span
                            class="white--text icon-stack-3x font-weight-bold"
                          >{{ props.item.shirt }}</span>
                        </div>
                      </td>
                      <td class="text-xs-center">
                        <v-layout row wrap justify-space-around>
                          <v-flex xs6>
                            <v-btn
                              :color="props.item.auxYellows>0? 'yellow darken-1': 'grey'"
                              flat
                              icon
                              @click.stop="props.item.auxYellows==0? props.item.auxYellows++ : props.item.auxYellows-- "
                            >
                              <v-icon class="mdi-rotate-90">mdi-card</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              :color="props.item.auxYellows>1? 'yellow darken-1': 'grey'"
                              flat
                              v-if="props.item.auxYellows>0"
                              icon
                              @click="props.item.auxYellows==1? (props.item.auxYellows++, props.item.auxReds<1? props.item.auxReds++:0) : props.item.auxYellows--"
                            >
                              <v-icon class="mdi-rotate-90">mdi-card</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </td>
                      <td>
                        <v-btn
                          :color="props.item.auxReds>0? 'red': 'grey'"
                          flat
                          icon
                          @click="props.item.auxYellows<2? props.item.auxReds==0? props.item.auxReds++ : props.item.auxReds-- : props.item.auxReds =1"
                        >
                          <v-icon class="mdi-rotate-90">mdi-card</v-icon>
                        </v-btn>
                      </td>
                    </template>
                    <v-alert type="warning" slot="no-data" :value="true">Escale jogadores</v-alert>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
          <v-spacer></v-spacer>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" icon @click="dialog=false, submitCards()">
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <v-btn block @click="dialog=true" color="primary">
          <v-icon left dark color="white">mdi-cards</v-icon>Atribuir Cartão
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      teamsTabs: 0,
      headers: [
        { text: "Atleta", align: "center", value: "name", sortable: false },
        { text: "Amarelo", align: "center", value: "yellows", sortable: false },
        { text: "Vermelho", align: "center", value: "red", sortable: false }
      ]
    };
  },
  methods: {
    submitCards() {
      var cardPapers = [];

      this.homeTeam.squads.forEach(element => {
        for (var i = 0; i < element.auxYellows; i++) {
          const paper = {};
          paper.event_time = null;
          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = element.squad_number_id;
          paper.shirt = element.shirt;
          paper.player = element.player_name;
          paper.champ_team_id = this.homeTeam.id;
          paper.kind = "cartão amarelo";
          cardPapers.push(paper);
        }
        for (var i = 0; i < element.auxReds; i++) {
          const paper = {};
          paper.event_time = null;
          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = element.squad_number_id;
          paper.shirt = element.shirt;
          paper.player = element.player_name;
          paper.champ_team_id = this.homeTeam.id;
          paper.kind = "cartão vermelho";
          cardPapers.push(paper);
        }
      });

      this.awayTeam.squads.forEach(element => {
        for (var i = 0; i < element.auxYellows; i++) {
          const paper = {};
          paper.event_time = null;
          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = element.squad_number_id;
          paper.shirt = element.shirt;
          paper.player = element.player_name;
          paper.champ_team_id = this.awayTeam.id;
          paper.kind = "cartão amarelo";
          cardPapers.push(paper);
        }
        for (var i = 0; i < element.auxReds; i++) {
          const paper = {};
          paper.event_time = null;
          paper.match_id = this.oneMatch.data.id;
          paper.squad_number_id = element.squad_number_id;
          paper.shirt = element.shirt;
          paper.player = element.player_name;
          paper.champ_team_id = this.awayTeam.id;
          paper.kind = "cartão vermelho";
          cardPapers.push(paper);
        }
      });

      this.setCardPapers(cardPapers);
    },
    available_squad_numbers(squad) {
      return squad.filter(obj => obj.shirt > 0);
    },
    ...mapMutations({
      setCardPapers: "Match/setCardPapers"
    }),
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapGetters({
      homeTeam: "Match/teamA",
      awayTeam: "Match/teamB"
    }),
    ...mapState({
      oneMatch: state => state.Match.oneMatch,
      cardPapers: state => state.Match.cardPapers
    })
  },
  watch: {
    dialog(nv, ov) {
      //IMPROVISANDO PARA NAO LIMPAR EVENTOS AO ATUALIZAR A ESCALACAO
      if (nv) {
        this.homeTeam.squads.forEach(element => {
          element.auxYellows = 0;
          element.auxReds = 0;
        });
        this.awayTeam.squads.forEach(element => {
          element.auxYellows = 0;
          element.auxReds = 0;
        });

        this.cardPapers.forEach(card => {
          console.log(card);
          if (card.squad_number_id) {
            let homePlayer = this.homeTeam.squads.find(function(squad) {
              return squad.squad_number_id === card.squad_number_id;
            });

            if (homePlayer) {
              if (card.kind == "cartão amarelo") homePlayer.auxYellows++;
              if (card.kind == "cartão vermelho") homePlayer.auxReds++;
            }
            let awayPlayer = this.awayTeam.squads.find(function(squad) {
              return squad.squad_number_id === card.squad_number_id;
            });
            if (awayPlayer) {
              if (card.kind == "cartão amarelo") awayPlayer.auxYellows++;
              if (card.kind == "cartão vermelho") awayPlayer.auxReds++;
            }
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
.icon-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.icon-stack-1x,
.icon-stack-3x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.icon-stack-1x {
  line-height: inherit;
}
</style>